import React from 'react';

interface CardProps {
  children: React.ReactNode;
  title?: string | React.ReactNode;
  subtitle?: string;
  headerActions?: React.ReactNode;
}

// The card is the workhorse surface of every admin and member page, so the whole app's texture
// comes from this one file. A real border and a soft shadow replace the previous `shadow-slate-200`
// with no `shadow` class beside it, which rendered nothing at all.
//
// The header carries a gold hairline: gold as a RULE on a light ground is allowed and is the
// cheapest place to make the brand visible. Gold as header TEXT there would be 2.32:1.
const Card: React.FC<CardProps> = ({
  children,
  title,
  subtitle,
  headerActions,
}) => (
  <div className="m-4 overflow-hidden rounded-lg border border-gray-200 bg-white text-ink shadow-sm dark:border-white/10 dark:bg-white/5 dark:text-white/80">
    {(title || subtitle || headerActions) && (
      <div className="border-b-2 border-primary px-6 py-4">
        {/* The header wraps rather than squeezing the title. In a three-across grid a card is
            about 274px wide, which left the title 138px once the action had taken its share, so
            "Home Courses" broke onto two lines and the three cards no longer lined up. The
            basis-40 floor makes the action drop to its own line instead, once there is less than
            10rem for the title. At full width nothing moves. */}
        <div className="flex flex-wrap items-start justify-between gap-x-4 gap-y-2">
          <div className="min-w-0 flex-1 basis-40">
            {title && (
              <h3 className="font-display text-lg font-semibold text-ink dark:text-white">
                {title}
              </h3>
            )}
            {subtitle && (
              <p className="mt-1 max-w-measure text-sm text-ink-muted dark:text-white/60">
                {subtitle}
              </p>
            )}
          </div>
          {headerActions && (
            <div className="ml-auto shrink-0">{headerActions}</div>
          )}
        </div>
      </div>
    )}
    <div className="p-6">
      <div>{children}</div>
    </div>
  </div>
);

export default Card;
